<template>
  <div class="ui-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t('spot.addStaysBtn') }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancel">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body ui-modal-body">
        <AddStayModal
          :venue="venue"
          :coordinates="coordinates"
          v-on:link="onApply"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import AddStayModal from '@/components/features/modals/add-stay-modal/add-stay-modal.vue';
  import isFunction from 'lodash/isFunction';

  export default {
    components: {
      AddStayModal
    },
    props: {
      updateCallback: {
        required: true
      },
      venue: {
        required: true
      },
      coordinates: {
        required: true
      },
    },
    data: function() {
      return {};
    },
    methods: {
      onApply: function (value) {
        if (isFunction(this.updateCallback)) {
          this.updateCallback(value);
          this.cancel();
        }
      },
      cancel: function () {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
.ui-modal {
  .ui-modal-body {
    max-height: 800px;
    overflow: auto;
  }
}
</style>
